export const habaCheckout = {
  habaOrderSummary: {
    subTotal: 'Valeur des marchandises',
    shipping: "Frais d'expédition",
    shippingSPED: "Frais d'expédition, y compris les frais de transport",
    totalDiscounts: 'Réductions',
    promotionSavings: 'Économies sur les promotions',
    promotionCoupons: "Avantage de l'action",
    totalSavings: 'Économie totale:',
    giftCard: "Bons d'achat",
    giftCards: "Bons d'achat",
    giftCardsResidualValue: 'Bon de valeur résiduelle',
    total: 'Somme totale',
    safeSSL: 'Tes données sont transmises en toute sécurité grâce au cryptage SSL.',
    help: "Vous avez besoin d'aide?",
    subHelp1: 'Contacter',
    subHelp2: 'ici notre service clientèle',
    btn: {
      label_0: 'Passer au mode de paiement',
      label_1: "Aller à l'aperçu",
      label_2: "Aller à l'aperçu",
    },
    helperTitle: 'Vorteilscode und Gutscheine können im letzten Schritt eingelöst werden.',
    portoFlatrate: {
      title: 'Frais de port offerts:',
      text: 'une fois <strong>{{price}}</strong> ensuite {{days}} jours sans frais de port dans tout {{country}}.',
      moreInfo: 'Apprendre',
      more: 'plus',
      expirationInfo: "Forfait frais de port valable jusqu'au {{expirationDate}}",
      cancel: 'Supprimer',
    },
    promotionsGiftcardInfo:
      "Les codes de promotion et les bons d'achat peuvent être utilisés à la dernière étape.",
    promotionsInfo: 'Les codes de promotion peuvent être utilisés à la dernière étape.',
    promotionsInfoTemporary:
      "Pour l'instant, il n'est malheureusement pas possible d'échanger des codes promotionnels, mais nous travaillons d'arrache-pied pour que cela soit à nouveau possible prochainement.",
    minAmountForFreeDelivery:
      'À partir de&nbsp;<strong>{{amount}}</strong>&nbsp;la livraison est&nbsp;<strong>gratuite!</strong>',
    backToShopping: 'Retour au Shopping',
    untilFreeCost: "jusqu'à frais de livraison gratuits!",
  },
  habaConfirmation: {
    thankYouHeading: 'Merci beaucoup pour ta commande!',
    thankYouText:
      "Tu recevras la confirmation de ta commande et des informations supplémentaires sur le droit de rétractation et les retours par e-mail à l'adresse suivante",
    total: 'Montant total',
    haveOneSecond: 'Encore quelques secondes?',
  },
  habaPayment: {
    paymentMethod: 'Mode de paiement',
    paymentMethodNotSelected: 'Veuillez sélectionner un mode de paiement.',
    paymentMethodNotActive: {
      title: 'Veuillez essayer un autre mode de paiement.',
      message:
        "<b>Le paiement par facture n'est pas possible</b> car votre adresse de facturation se trouve en dehors de l'Allemagne, de l'Autriche et de la Suisse.",
    },
    birthdateModal: {
      title: 'Veuillez prouver votre identité',
      paragraph:
        "Pour ce mode de paiement, nous avons besoin de données supplémentaires pour prouver votre identité. Après cela, vous pouvez finaliser votre achat. Cela s'applique au nôtre",
      dataProtection: 'Protection des données',
      inputPlaceholder: "Date d'anniversaire (TT.MM.JJJJ)",
      submitButton: 'Confirmer',
      dataProtectionLink: 'Déclaration de confidentialité',
      dataProtectionText: "Il s'agit de notre",
    },
    birthdateError: {
      title: 'Mode de paiement malheureusement non autorisé.',
      paragraph:
        "Malheureusement, vous n'êtes pas autorisé à utiliser ce mode de paiement. Veuillez essayer un autre mode de paiement.",
    },
    disabledPaymentMethods: {
      and: 'ou',
      isDisabledForGiftCards:
        '{{restrictedPaymentMethods}} ne peut pas être utilisé avec <b>les cartes cadeaux</b>.',
      isDisabledForPortoFlatrate:
        "{{restrictedPaymentMethods}} ne peut être utilisé pendant l'acquisition de <b>Porto-Flaterate.</b>",
    },
    submitButton: 'Fermer',
    termsAndConditions:
      "Oui, j'accepte les conditions générales. Vous trouverez ici notre déclaration de protection des données",
    standardPaymentInfoTip:
      "Notre expédition standard est assurée par des prestataires de services d'expédition établis tels que <b>UPS or DHL</b>. Nous choisissons le partenaire le plus approprié en fonction du livreur qui offre la meilleure prestation dans votre région.",
    paymentModes: {
      ct_paypal: 'PayPal',
      ct_creditcard_hop: 'Carte de crédit',
      advancePayment: 'Avance',
      invoice: 'Facture',
    },
    paymentModesDescription: {
      ct_paypal:
        "Le paiement via PayPal est simple, rapide et sécurisé ! Remarque : tes données te seront demandées après l'envoi de la commande. Tu dois saisir tes données PayPal à chaque achat. Lors du paiement via PayPal, tu seras redirigé vers le site Web de PayPal. Les conditions générales de PayPal s'appliquent.",
      ct_creditcard_hop:
        'Après avoir envoyé ta commande, tu seras redirigé vers la page de paiement par carte bancaire (HOP hosted order page).',
      advancePayment: "Le paiement peut être effectué à l'avance.",
      invoice:
        "Paiement après réception de la marchandise. Tu paies le montant de la facture en toute simplicité par virement bancaire dans un délai de 14 jours. Nous t'envoyons la facture de préférence par e-mail (pièce jointe au format PDF).",
    },
  },
  habaPlaceOrder: {
    agb: 'Oui, j\'accepte les <a href="{{agbUrl}}" target="_blank" rel="noopener noreferrer">conditions générales</a>.',
    dataProtection:
      'Vous trouverez ici nos déclarations de <a href="{{privacyUrl}}" target="_blank" rel="noopener noreferrer">protection des données</a>.',
    placeOrder: 'Commande payante maintenant',
    agbError:
      'Veuillez confirmer que vous avez lu et accepté nos conditions générales et notre déclaration de confidentialité.',
    phoneModal: {
      title: 'Modifier le numéro de téléphone',
      text: 'Votre numéro de téléphone est requis, pour que le transporteur puisse vous contacter',
      inputPlaceholder: 'Numéro de téléphone',
      submitButton: 'Enregistrer et continuer',
    },
    phoneErrorMessage:
      'Votre numéro de téléphone <b>est requis</b>, pour que <b>le transporteur puisse vous contacter</b>.',
    phoneSuccessMessage:
      "Le format du numéro de téléphone semble être correct. Veuillez d'abord enregistrer vos mises à jour, puis <b>Commander maintenant</b>.",
  },
  habaGuestLogin: {
    heading: "Commander en tant qu'invité",
    emailAddress: {
      label: 'Adresse électronique',
      error: 'Veuillez saisir une adresse e-mail valide.',
    },
    emailConfirmationAddress: {
      label: "Confirmer l'adresse e-mail",
      error: "L'adresse e-mail et la répétition de l'e-mail ne correspondent pas.",
    },
    button: "Vers la commande d'invité",
  },
  habaCheckoutProgress: {
    login: "S'inscrire",
    methodOfPayment: 'Mode de paiement',
    shippingAddress: 'Adresse',
    deliveryMode: 'Mode de livraison',
    paymentDetails: 'Paiement',
    reviewOrder: 'Confirmer',
  },
  habaCheckoutInforbarText: {
    freeReturn: 'Retour gratuit sous 14 jours',
    noMinimumOrderValue: 'Aucun montant minimum de commande',
    carefullyTestedProducts: 'Produits soigneusement testés',
    sparePartService: 'Service de pièces détachées',
  },
  habaCheckoutReview: {
    review: 'Votre aperçu',
    cardTitle: {
      shippingAddress: 'Adresse de livraison',
      billingAddress: 'Adresse de facturation',
      paymentMethod: 'Mode de paiement',
      deliveryMethod: 'Mode de livraison',
      email: 'Adresse e-mail',
      telephone: 'Numéro de téléphone',
    },
    errors: {
      syncAtpCheckProductNotAvailable:
        "Le stock n'est plus disponible. Un ou plusieurs produits ont été retirés de votre panier.",
      syncAtpCheckProductQuantityChanged:
        "Le stock n'est plus disponible. Les quantités d'un ou de plusieurs produits ont été réduites.",
      generic:
        'La commande ne peut pas être terminée. Veuillez réessayer plus tard ou contacter notre équipe de support.',
      syncAtpCheckProductNotAvailableQuantityChanged:
        "Le stock n'est plus disponible. Un ou plusieurs produits ont été retirés de votre panier et les quantités d'un ou plusieurs produits ont été réduites.",
      cartItemsPriceChanged: 'Price has changed',
      giftCardsRemoved:
        'Une ou plusieurs cartes-cadeaux ont été retirées. Veuillez les ajouter à nouveau.',
      invalidPaymentDetails: 'Veuillez mettre à jour votre méthode de paiement.',
      companyAddressesChanged:
        'Les données de votre entreprise ont changé. Veuillez sélectionner à nouveau vos adresses.',
    },
  },
  habaDeliveryModes: {
    title: 'Expédition',
    'standardversand-haba-de': 'Expédition standard',
  },
};
